class FavouritesHeart extends window.BAO.CustomElement({
  SuperClass: HTMLButtonElement,
}) {
  static requiredAttributes () {
    return ['data-type', 'data-handle']
  }

  connectedCallback () {
    super.connectedCallback()

    this.locked = false

    this.setActiveState()
  }

  setupListeners () {
    super.setupListeners()

    this.onHeartClicked = this.onHeartClicked.bind(this)

    this.listeners.add(this, 'click', this.onHeartClicked)

    document.addEventListener('wishlist:favouritesUpdated', () => {
      this.setActiveState()
    })
  }

  setActiveState () {
    this.classList.remove('wlt-Heart-active')
    if (this.active) {
      this.classList.add('wlt-Heart-active')
    }
  }

  async onHeartClicked () {
    if (this.token === '') {
      window.BAO.wishlist.redirectToLogin()
      return
    }

    if (this.locked) return

    this.locked = true

    if (this.active) {
      this.removeActiveClass()
      await window.BAO.wishlist.removeFavourite(this.record.id, this.token)
    } else {
      this.addActiveClass()
      await window.BAO.wishlist.addFavourite(this.type, this.handle, this.token)
    }

    await window.BAO.wishlist.updateFavourites(this.token)

    this.locked = false
  }

  addActiveClass () {
    this.classList.add('wlt-Heart-active')
  }

  removeActiveClass () {
    this.classList.remove('wlt-Heart-active')
  }

  get type () {
    return this.dataset?.type
  }

  get handle () {
    return this.dataset?.handle
  }

  get token () {
    return window.BAO.wishlist.token
  }

  get active () {
    return this.record
  }

  get record () {
    const records = window.BAO.wishlist.favourites?.[`${this.type}s`] || []
    return records.find(
      r => r.handle === this.handle || r.list_id === this.handle,
    )
  }
}

customElements.define('favourites-heart', FavouritesHeart, {
  extends: 'button',
})
